import React from 'react'

import { theme } from '../../constants/ui/theme'

const Check = ({ background = theme.textPrimary, className }) => (
  <svg width="18" height="16" viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
    <path
      d="M1.61719 8.6838L7.52488 14.1539L16.3864 1.84619"
      stroke={background}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export default Check
